const MB = 1024 * 1024;
const MB_FORMATTER = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 1 });

/** Tamanho do arquivo como no protótipo: "340 KB", "2,8 MB". */
export function formatFileSize(bytes: number): string {
  if (bytes < MB) return `${Math.max(1, Math.round(bytes / 1024))} KB`;

  return `${MB_FORMATTER.format(bytes / MB)} MB`;
}

/** Nome do arquivo no endereço da imagem; o rótulo quando o endereço não traz um. */
export function fileNameFromUrl(url: string, fallback: string): string {
  try {
    const name = new URL(url, window.location.href).pathname.split("/").pop();
    return name ? decodeURIComponent(name) : fallback;
  } catch {
    return fallback;
  }
}
